import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function OfflineBanner() {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(!navigator.onLine);
  const [visible, setVisible] = useState(!navigator.onLine);

  useEffect(() => {
    let autoHideTimer: ReturnType<typeof setTimeout>;

    const handleOffline = () => {
      setOffline(true);
      setVisible(true);
    };
    const handleOnline = () => {
      setOffline(false);
      setVisible(true);
      autoHideTimer = setTimeout(() => setVisible(false), 3000);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
      clearTimeout(autoHideTimer);
    };
  }, []);

  if (!visible) return null;

  const cls = offline
    ? 'offline-banner offline-banner--offline'
    : 'offline-banner offline-banner--online';

  return (
    <div className={cls} role="status" aria-live="polite">
      <span className="offline-banner__text">
        {offline ? t('offline.title') : t('offline.backOnline')}
      </span>
    </div>
  );
}
